const UPDATE = 'pulp/uploadProgress/UPDATE';

export const initialState = 0;

export default function reducer (state = initialState, action) {
  switch(action.type) {
    case UPDATE:
      return action.payload;
    default:
      return state;
  }
}

export function updateUploadProgress(uploadProgress) {
  return {type: UPDATE, payload: uploadProgress};
}